import { Outlet } from 'react-router-dom';

import LoginNav from '@modules/layout/templates/login-nav';

/**
 * Account Setup layout - 極簡佈局，僅有 Logo 導航
 * 用於新客戶首次設定帳號密碼的流程，不需要認證
 */
export default function AccountSetupLayout() {
  return (
    <div className="relative w-full bg-white">
      <LoginNav isLoggedIn={false} />
      <main className="px-4 py-12">
        <Outlet />
      </main>
    </div>
  );
}
